module.exports = __webpack_public_path__ + "img/cumpleanios-cake.f28a7ad0.svg";